// @flow
import React from 'react';
import styled, { withTheme } from 'styled-components';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { type Item } from 'common/components/DropDownMenu';
import Radio from 'common/domain/radio';
import Theme from 'statsradio/themes';
import { getRadio } from 'statsradio/modules/authentication/session/reducers/sessionReducer';
import { getToken } from 'statsradio/modules/authentication/session/selectors/sessionSelectors';
import FlatDropDownMenu from 'common/components/FlatDropDownMenu';
import { SELECT_ALL_SALES_MEMBERS } from 'statsradio/modules/campaigns/domain/CampaignV2Filters';
import type { SalesMember } from '../domain/SalesMember';
import SalesMembersApi from '../services/SalesMembersApi';

export const SALES_MEMBERS_DROPDOWN_MENU = 'SALES_MEMBERS_DROPDOWN_MENU';

const Icon = styled.i`
  margin-left: ${({ theme }) => theme.metrics.smallMargin}px;
  color: #4c4c4c;
`;

export const SalesMemberDropdownSelection = {
  SELECTED_ALL: 'SELECTED_ALL',
  SELECTED_ONE: 'SELECTED_ONE',
};
export type SalesMemberDropdownSelectionType = $Values<typeof SalesMemberDropdownSelection>;

type Props = {
  selectedMember?: SalesMember;
  onSelectMembers: (selection: SalesMemberDropdownSelectionType, member?: SalesMember) => void,
  style?: Object,
  showIcon?: boolean,

  radio: Radio,
  token: string,

  t: any,
  theme: typeof Theme,
};

type State = {
  loading: boolean;
  salesMembers: SalesMember[],
}

export class SalesMembersDropdown extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = {
      loading: false,
      salesMembers: [],
    };
  }

  async componentDidMount() {
    await this.fetchSalesMembers();
  }

  async componentDidUpdate(prevPros: Props) {
    const { radio } = this.props;

    if (!prevPros.radio.isSame(radio)) {
      await this.fetchSalesMembers();
    }
  }

  async fetchSalesMembers() {
    const { token, radio } = this.props;
    this.setState({ loading: true });

    try {
      const salesMembers = await SalesMembersApi.fetchSalesMembers(token, radio.callSign);
      this.setState({ salesMembers, loading: false });
    } catch (error) {
      this.setState({ loading: false });
    }
  }

  generateDropdownItems(): Item[] {
    const { salesMembers } = this.state;

    const selectAllMembers = [{ label: this.props.t('allSalesMembers'), value: SELECT_ALL_SALES_MEMBERS }];
    const members = salesMembers.map(member => ({ label: member.fullName, value: member }));
    return selectAllMembers.concat(members);
  }

  onSelectionChanged = (value: string | SalesMember) => {
    if (value === SELECT_ALL_SALES_MEMBERS) {
      this.props.onSelectMembers(SalesMemberDropdownSelection.SELECTED_ALL);
    } else {
      this.props.onSelectMembers(SalesMemberDropdownSelection.SELECTED_ONE, value);
    }
  };

  render() {
    const { theme: { V2 }, showIcon } = this.props;

    return (
      <FlatDropDownMenu
        id={SALES_MEMBERS_DROPDOWN_MENU}
        icon={() => {
          return (showIcon && <Icon className="material-icons">person</Icon>);
        }}
        value={this.props.selectedMember || SELECT_ALL_SALES_MEMBERS}
        items={this.generateDropdownItems()}
        extraTextStyle={{
          fontFamily: V2.fonts.family,
        }}
        onChange={this.onSelectionChanged}
        selectedTextColor={V2.colors.primary}
      />
    );
  }
}

function mapStateToProps(state: *) {
  return {
    radio: getRadio(state),
    token: getToken(state),
  };
}

export default translate('salesMembers')(connect(mapStateToProps)(withTheme(SalesMembersDropdown)));



// WEBPACK FOOTER //
// ./src/statsradio/modules/salesMembers/components/SalesMembersDropdown.js